import * as yup from 'yup';

export const validationSchema = yup.object({
  password: yup.string().required('app.error.password-required'),
  confirmPassword: yup
    .string()
    .required('app.error.password-required')
    .oneOf([yup.ref('password'), ''], 'Passwords must match'),
});
